import { PageContainer } from "ui/layout/Containers";
import { RealmSelector } from "pages/authorization/RealmSelector";

export const SelectRealmPage = () => {
  return (
    <PageContainer>
      <RealmSelector />
    </PageContainer>
  );
}